<template>
    <div>
        <section class="cabinet-table-options-wrap mb-0">
            <div class="cabinet-table-options flex flex-align-center pt-0 pb-0">
                <div class="d-none d-md-block">
                    <div class="loading-state__pagination-info"></div>
                </div>

                <div
                    class="cabinet-table-options__sort flex flex-align-center ml-md-auto"
                >
                    <div class="loading-state__sort mr-2"></div>
                    <div class="loading-state__view ml-auto"></div>
                </div>
            </div>

            <div
                class="cabinet-table-options flex flex-justify-sb flex-align-center pt-0 pb-0"
            >
                <section
                    class="cabinet-table-options flex flex-justify-sb flex-align-center d-flex"
                >
                    <div class="d-none d-md-block">
                        <div class="loading-state__pagination-size"></div>
                    </div>
                    <div class="d-md-none">
                        <div class="loading-state__pagination-info"></div>
                    </div>
                </section>

                <div
                    class="cabinet-table-options-pagination flex flex-justify-sb flex-align-center d-none d-md-flex"
                >
                    <div class="loading-state__pagination"></div>
                </div>
            </div>
        </section>

        <div class="cabinet__catalog">
            <div
                class="cabinet__catalog-container d-flex flex-wrap justify-content-between"
            >
                <div
                    v-for="(item, i) in Array(12)"
                    :key="i"
                    class="cabinet__catalog-item"
                >
                    <div class="cabinet__catalog-favorite">
                        <div class="cabinet-favorite-checkbox">
                            <input type="checkbox" name="favorite" value="1" />
                        </div>
                    </div>

                    <div
                        class="cabinet__catalog-image loading-state__catalog-image-wrap"
                    ></div>

                    <div class="cabinet__catalog-top">
                        <div
                            class="cabinet__catalog-title d-flex align-items-center"
                        >
                            <div class="loading-state__catalog-title"></div>
                        </div>
                        <div class="cabinet__catalog-category truncate pt-2">
                            <div class="loading-state__catalog-cat"></div>
                        </div>
                    </div>

                    <div
                        class="cabinet__catalog-tags d-flex flex-wrap subtitle2"
                    >
                        <div class="loading-state__catalog-tag"></div>
                    </div>

                    <div class="cabinet__catalog-info">
                        <div class="loading-state__catalog-price"></div>
                    </div>
                    <div
                        class="cabinet__catalog-form d-flex align-items-center w-100"
                    >
                        <div class="loading-state__catalog-cart"></div>
                    </div>
                </div>
            </div>
        </div>

        <section
            class="cabinet-table-options flex flex-justify-sb flex-align-center d-none d-lg-flex"
        >
            <div class="loading-state__pagination-size"></div>

            <div
                class="cabinet-table-options-pagination flex flex-justify-sb flex-align-center"
            >
                <div class="loading-state__pagination"></div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'ProductsLoading'
}
</script>
